import { TAX_TYPE_DEFAULTS } from '@trellis/shared'
import type { InvoiceTaxType } from '@trellis/shared'

import { useOrganization } from './useOrganization'

/** Returns the canonical default rate for a given tax type. */
export function getDefaultRateForType(type: InvoiceTaxType): number {
  return TAX_TYPE_DEFAULTS[type]
}

/**
 * Returns the organisation's default tax type and rate for pre-filling new document
 * forms. Both values are null when no default has been configured.
 */
export function useTaxDefaults() {
  const { data: organizationResult } = useOrganization()
  const organization = organizationResult?.data ?? null

  return {
    defaultTaxType: organization?.defaultTaxType ?? null,
    defaultTaxRate: organization?.defaultTaxRate ?? null,
  }
}
